import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { Link, navigate } from "gatsby";
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import { Box, ClickAwayListener, Grow, MenuItem, MenuList, Paper, Popper } from "@material-ui/core";
import MobileDrawer from "./MobileDrawer";

const useStyles = makeStyles((theme) => ({
  link: {
    color: 'inherit',
    textDecoration: 'none'
  },
  navs: {
    alignItems: 'center',
    display: 'flex',
    [theme.breakpoints.up('sm')]: {
      justifyContent: 'space-between'
    },
    justifyContent: 'flex-start'
  }
}));

const Header = ({ siteTitle }) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  function handleListKeyDown(event) {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen(false);
    }
  }

  const handleClick = (to) => {
    navigate(to);
  }

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = useRef(open);
  useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open]);
  const linkNavs = [
    {
      title: 'Jogja',
      to: '/jogja',
    },
    {
      title: 'Sleman',
      to: '/sleman',
    },
    {
      title: 'Bantul',
      to: '/bantul',
    },
    {
      title: 'Kulon Progo',
      to: '/kulon-progo',
    },
    {
      title: 'Gunungkidul',
      to: '/gunungkidul',
    },
    {
      title: 'Wonosari',
      to: '/wonosari',
    },
    {
      title: 'Solo',
      to: '/solo',
    },
    {
      title: 'Klaten',
      to: '/klaten',
    },
    {
      title: 'Wates',
      to: '/wates',
    },
  ]
  
  return (
    <AppBar position="relative">
      <Toolbar className={classes.navs}>
        <MobileDrawer handleClick={handleClick} linkNavs={linkNavs} />
        <Typography variant="h5" color="inherit" noWrap>
          <Link
            className={classes.link}
            to="/"
            >
            {siteTitle}
          </Link>
        </Typography>
        <Box display={{ xs: 'none', sm: 'block' }}>
          <Typography variant="h5" color="inherit" noWrap>
            <Link
              aria-controls={open ? 'menu-list-grow' : undefined}
              aria-haspopup="true"
              className={classes.link}
              to="#"
              ref={anchorRef}
              onClick={handleToggle}
              >
              Daftar Area
            </Link>
          </Typography>
        </Box>
      </Toolbar>
      <Popper open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal>
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
            >
              <Paper>
                <ClickAwayListener onClickAway={handleClose}>
                  <MenuList autoFocusItem={open} id="menu-list-grow" onKeyDown={handleListKeyDown}>
                    {linkNavs.map((item, index) => (
                      <MenuItem key={index} onClick={() => handleClick(item.to)}>{item.title}</MenuItem>
                    ))}
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
    </AppBar>
  )
}

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
